import axios from 'axios';
import { config_headers, URL_API ,servicelist } from '../Config';

export const P300DashboardList = async (body) => {
    return new Promise(async (resolve, reject) => {
        try {
            let authorization = await config_headers();
            // console.log('authorization ',authorization.headers , body);
            await axios.post(URL_API(`${servicelist.ExecutiveService}p_executive_dashboard_corporate_info`), body, authorization )
                .then(res => {
                    resolve(res.data);
                });
        }
        catch (err) {
            reject(err);
        }
        finally {

        }
    })
}

export const P300GetDataChart= async (body) => {

    return new Promise(async (resolve, reject) => {
        try {
            let authorization = await config_headers();
            // console.log('authorization ',authorization.headers);
            await axios.post(URL_API(`${servicelist.ExecutiveService}p_executive_dashboard_corporate_graph_1`), body, authorization )
                .then(res => {
                    resolve(res.data);
                });
        }
        catch (err) {
            reject(err);
        }
        finally {

        }
    })
}

export const P300BudgetList = async (body) => {
    return new Promise(async (resolve, reject) => {
        try {
            let authorization = await config_headers();
            // console.log('authorization ',authorization.headers , body);
            await axios.post(URL_API(`${servicelist.GenService}p_gen_budget_type_list`), body, authorization )
                .then(res => {
                    resolve(res.data);
                });
        }
        catch (err) {
            reject(err);
        }
        finally {

        }
    })
}


